import { Observable } from 'rxjs';
import { ProductCollection } from 'src/app/core/interfaces/store-configuration.interface';
import { Category, Product, ProductDealCountdown } from 'src/app/products/models/product.model';
import { Banner, HomeContentType, SelectedProduct } from './home.model';

export interface CarouselProduct {
  name: string;
  display_name: string;
  category: string;
  image: string;
  url_path: string;
  one_line_description?: string;
  sellingPrice: number;
  percentSavings: number;
  actualPrice: number;
  mrp: number;
  productSellingPrice: number;
  in_stock: boolean;
  id: string;
  cashbackPoints?: number;
  deal?: ProductDealCountdown;
}
export class HomeContent {
  constructor(
    public id: string,
    public title: string,
    public description: string,
    public search_keywords: string[],
    public position: number,
    public is_active: boolean,
    public is_primary: boolean,
    public state: PublishStatus,
    public type: HomeContentType,
    public is_archived: boolean,
    public seller_company: string,
    public banner_sections: Banner[],
    public product_list: SelectedProduct[],
    public product_tags: ProductTags[],
    public brands: Brand[],
    public categories: Category[],
    public products: Product[],
    public productsFilteredByTags$: Observable<{
      state: string;
      response: Product;
    }>,
    public collections: any,
    public product_collection: ProductCollection
  ) { }
}
export class HomeContentMappedProductList {
  constructor(
    public id: string,
    public title: string,
    public description: string,
    public search_keywords: string[],
    public brands: Brand[],
    public position: number,
    public is_active: boolean,
    public is_primary: boolean,
    public state: PublishStatus,
    public categories: Category[],
    public type: string,
    public is_archived: boolean,
    public seller_company: string,
    public banner_sections: Banner[],
    public product_tags: ProductTags[],
    public productListState$: Observable<{
      state: string;
      response: CarouselProduct[];
    }>,
    public productsFilteredByTags$: Observable<{
      state: string;
      response: CarouselProduct[];
    }>,
    public products: Product[],
    public product_list: any[],
    public productsFilteredByCollections$: Observable<any>,
    public layout: number,
    public product_collection: ProductCollection
  ) { }
}

export class Brand {
  constructor(public logo?: null, public name?: string) { }
}

export enum ProductTags {
  BEST_SELLER = 'Best Seller',
  TRENDING = 'Trending',
  LATEST = 'Latest',
  RECOMMENDED = 'Recommended'
}

export enum PublishStatus {
  draft = 'draft',
  published = 'published'
}
